import type { LucideIcon } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';

interface PlaceholderPageProps {
  readonly title: string;
  readonly session: number;
  readonly icon: LucideIcon;
}

export function PlaceholderPage({ title, session, icon: Icon }: PlaceholderPageProps) {
  return (
    <div>
      <PageHeader title={title} />
      <div className="mt-16 flex flex-col items-center justify-center text-center">
        <Icon className="mb-4 h-16 w-16 text-muted-foreground/30" />
        <p className="text-lg font-medium text-muted-foreground">
          Coming in Session {session}
        </p>
        <p className="mt-1 text-sm text-muted-foreground/70">
          This page will be built in a future session.
        </p>
      </div>
    </div>
  );
}
